module.exports = __webpack_public_path__ + "static/assets/4a5c89b15b53387bcbe0ddcea306fab7.png";